export default __webpack_public_path__ + "static/media/activity.849372e0.svg";